import { FormControl, Select, MenuItem } from '@mui/material';
import React from 'react';

interface AdminSelectProps {
    fields: string[];
    selected: string;
    onChange: (value: string) => void;
}

export default function AdminSelect({ fields, selected, onChange }: AdminSelectProps) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (event: any) => {
        // eslint-disable-next-line no-comments/disallowComments
        // SelectChangeEvent can't be found in package
        onChange(event.target.value);
    };

    return (
        <FormControl fullWidth variant="standard">
            <Select value={selected} onChange={handleChange}>
                {fields.map((field) => (
                    <MenuItem key={field} value={field}>
                        {field}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
